class KlaviyoPopup extends HTMLElement {
    constructor() {
        super();

        this.companyId = this.dataset.companyId;

        // Elements
        this.container = this.querySelector('.klaviyo-bis__modal-container');
        this.form = this.querySelector('form');
        this.emailInput = this.querySelector('[name="email"]');
        this.phoneInput = this.querySelector('[name="phone"]');
        this.variantInput = this.querySelector('#product');
        this.productTitle = this.querySelector('.product-title');
        this.button = this.form?.querySelector('button');
        this.buttonText = this.button?.innerText;

        // Close buttons
        this.closeButton = this.querySelector('.close_modal_btn');

        // Bind
        this.submitHandler = this.handleSubmit.bind(this);
    }

    connectedCallback() {
        this.hide();

        // Listen for triggers
        document.querySelectorAll('.custom-klaviyo-bis-trigger').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const title = btn.dataset.productTitle;
                const variantId = btn.dataset.productVariant;

                this.open(title, variantId);
            });
        });

        this.closeButton?.addEventListener('click', () => this.hide());

        // Close when clicking outside container
        this.addEventListener('click', (e) => {
            if (!this.container.contains(e.target)) this.hide();
        });

        this.form.addEventListener('submit', this.submitHandler);
    }

    open(productTitle, variantId) {
        this.classList.add('active');

        // Fill modal info
        this.productTitle.textContent = productTitle;
        this.variantInput.value = variantId;

    }

    hide() {
        this.classList.remove('active');
    }

    async handleSubmit(event) {
        event.preventDefault();

        const email = this.emailInput.value.trim();
        const phone = this.phoneInput.value.trim();
        const variantId = this.variantInput.value;

        if (!email.length) return;

        const compoundVariantId = `$shopify:::$default:::${variantId}`;

        const body = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email,
                                "phone_number": phone
                            }
                        }
                    },
                    "channels": ["EMAIL"],
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": compoundVariantId
                        }
                    }
                }
            }
        };

        const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`;

        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Revision': '2024-05-15'
                },
                body: JSON.stringify(body)
            });

            if (res.ok) {
                this.showSuccess();
            }
        } catch (err) {
            console.error(err);
        }
    }

    showSuccess() {
        if (this.button) {
            this.button.classList.add('success-submitted');
            this.button.innerText = "submitted";
        }
        // auto close
        setTimeout(() => this.hide(), 1500);
    }
}

customElements.define('klaviyo-popup', KlaviyoPopup);
